import { useState } from "react";
import InputComponent from "./InputComponent";
import styles from "../../styles/About.module.scss";
import Button from "./SendButton";
import React from 'react';
import axios from "axios"
import { Redirect } from "react-router-dom"

const ContactForm = () => {
  const [data, setData] = useState(
    {
      name: "",
      email: "",
      message: "",
      date: Date.now()
    })
  const [redirect, setRedirect] = useState(false)

  const onFormSubmit = () => {
    axios.post('https://sheet.best/api/sheets/d36fd4ff-c134-494b-97bd-cc3dbe3f3da5', data)
      .then(response => {
        setRedirect(true)
      }).catch(err => console.log("error", err))
  }

  return (
    redirect ?
      <Redirect to="/aboutme" /> :
      <form>
        <div className={styles.connectform}>
          <div>
            <InputComponent placeholder="Your name" onchange={(e) => setData((prevdata) => ({
              ...prevdata,
              name: e.target.value
            }))} />
            <InputComponent placeholder="Email" type="email" onchange={(e) => setData((prevdata) => ({
              ...prevdata,
              email: e.target.value
            }))} />
          </div>
          <p>
            I believe in connecting with the world , making new friends and having
            fun while learning new stuff everyday!
          </p>
        </div>
        <textarea className={styles.message} placeholder="Message" onChange={(e) => setData((prevdata) => ({
          ...prevdata,
          message: e.target.value
        }))} />
        <Button title="SEND" type="submit" onClick={onFormSubmit} />
      </form>
  )
}

export default ContactForm